import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import { mailPattern, phoneNumber } from "../../variables/constants";
import toast from "react-hot-toast";
import { getServices, postServices } from "../../apiServices/apiServices";

function AdminDashboard() {
  const [isNextClicked, setIsNextClicked] = useState(false);
  const [fieldData, setFieldData] = useState({
    hardware_id: null,
    location_type: "",
    company_name: null,
    branch: null,
    co_person: "",
    co_person_no: "",
    co_person_email: "",
    pincode: "",
    district: "",
    state: "",
  });
  const [normalEmail, setNormalEmail] = useState(["", "", "", "", ""]);
  const [normalPhone, setNormalPhone] = useState(["", "", "", "", ""]);
  const [criticalEmail, setCriticalEmail] = useState(["", "", ""]);
  const [criticalPhone, setCriticalPhone] = useState(["", "", ""]);
  const [isValid, setIsValid] = useState({
    co_person_email: true,
    co_person_phone: true,
  });
  const [loading, setLoading] = useState(false);
  const [hardwareDropdownValues, setHardwareDropdownValues] = useState([]);
  const [headofficeDropdownValues, setHeadofficeDropdownValues] = useState([]);
  const [subBranchDropdownValues, setSubBranchDropdownValues] = useState([]);
  const navigate = useNavigate();
  const access_token = localStorage.getItem("gassol-admin-token");

  useEffect(() => {
    fetchHardwareList();
    fetchHeadOfficeList();
    // fetchSubbranchList();
  }, []);

  const fetchHardwareList = async () => {
    try {
      const res = await getServices(`/api/hardware/dropdowns`, access_token);
      if (res.responseCode === 200) {
        setHardwareDropdownValues(res.responseData);
      } else {
        setHardwareDropdownValues([]);
      }
    } catch (error) {
      toast.error(error);
    }
  };
  const fetchHeadOfficeList = async () => {
    try {
      const res = await getServices(`/api/list/my/headbranch`, access_token);
      if (res.responseCode === 200) {
        setHeadofficeDropdownValues(res.responseData);
      } else {
        setHeadofficeDropdownValues([]);
      }
    } catch (error) {
      toast.error(error);
    }
  };
  const fetchSubbranchList = async (headbranch_id) => {
    try {
      // const res = await getServices(`/api/list/my/subbranch`, access_token);
      const res = await getServices(
        `/api/list/nonactivated/subbranch?headbranch_id=${headbranch_id.value}`,
        access_token
      );

      if (res.responseCode === 200) {
        setSubBranchDropdownValues(res.responseData);
      } else {
        setSubBranchDropdownValues([]);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleNextClick = () => {
    if (fieldData.hardware_id === null) {
      toast.error("Please select a Hardware ID.");
    } else if (fieldData.location_type === "") {
      toast.error("Please select a Location Type");
    } else if (fieldData.company_name === null) {
      toast.error("Please select a Company Name");
    } else if (fieldData.branch === null && fieldData.location_type === "2") {
      toast.error("Please select a Branch");
    } else if (fieldData.co_person === "") {
      toast.error("Please enter a Person Name");
    } else if (fieldData.co_person_no === "") {
      toast.error("Please enter a Person Phone no.");
    } else if (!isValid.co_person_phone) {
      toast.error("Please enter a Valid Person Phone no.");
    } else if (fieldData.co_person_email === "") {
      toast.error("Please enter a Person Email");
    } else if (!isValid.co_person_email) {
      toast.error("Please enter a Valid Person Email");
    } else {
      window.scrollTo(0, 0);
      setIsNextClicked(true);
    }
  };

  const handleBackClick = (e) => {
    window.scrollTo(0, 0);
    setIsNextClicked(false);
  };

  const handleNormalEmailChange = (index, event) => {
    const newEmails = [...normalEmail];
    newEmails[index] = event.target.value;
    setNormalEmail(newEmails);
  };
  const handleNormalPhoneChange = (index, event) => {
    const newPhones = [...normalPhone];
    newPhones[index] = event.target.value.replace(/\D/g, "");
    setNormalPhone(newPhones);
  };
  const handleCriticalEmailChange = (index, event) => {
    const newEmails = [...criticalEmail];
    newEmails[index] = event.target.value;
    setCriticalEmail(newEmails);
  };
  const handleCriticalPhoneChange = (index, event) => {
    const newPhones = [...criticalPhone];
    newPhones[index] = event.target.value.replace(/\D/g, "");
    setCriticalPhone(newPhones);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const urlencoded = new URLSearchParams();

    // const cylindersArray = fieldData.no_of_cylinder.filter(
    //   (value) => value !== null
    // );

    urlencoded.append("hardware_id", fieldData.hardware_id?.value);
    urlencoded.append("location_type", fieldData.location_type);
    urlencoded.append("company_name", fieldData.company_name?.value);
    urlencoded.append("branch", fieldData.branch?.value);
    urlencoded.append("co_person", fieldData.co_person);
    urlencoded.append("co_person_no", "+91" + fieldData.co_person_no);
    urlencoded.append("co_person_email", fieldData.co_person_email);
    urlencoded.append("pincode", fieldData.pincode);
    urlencoded.append("district", fieldData.district);
    urlencoded.append("state", fieldData.state);
    for (let i = 0; i < normalEmail.length; i++) {
      urlencoded.append("normal_email", normalEmail[i]);
    }
    for (let i = 0; i < normalPhone.length; i++) {
      if (normalPhone[i].length > 0) {
        urlencoded.append("normal_phone", "+91" + normalPhone[i]);
      } else {
        urlencoded.append("normal_phone", "");
      }
    }
    for (let i = 0; i < criticalEmail.length; i++) {
      urlencoded.append("critical_email", criticalEmail[i]);
    }
    for (let i = 0; i < criticalPhone.length; i++) {
      if (criticalPhone[i].length > 0) {
        urlencoded.append("critical_phone", "+91" + criticalPhone[i]);
      } else {
        urlencoded.append("critical_phone", "");
      }
    }
    // urlencoded.append("manifold", fieldData.manifold?.value);
    // urlencoded.append("ws_status", fieldData.ws_status);
    // urlencoded.append("type_of_cylinder", fieldData.type_of_cylinder?.label);
    // for (let i = 0; i < cylindersArray.length; i++) {
    //   urlencoded.append("no_of_cylinder", cylindersArray[i]);
    // }

    try {
      const res = await postServices(
        `/api/hardware/activate`,
        urlencoded,
        access_token
      );
      setLoading(false);
      if (res.responseCode === 200) {
        navigate("/admin/admin_controller/1");
        toast.success("Hardware activated...");
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  return (
    <div className="bg-white p-5 md:px-8 w-full">
      <div className="pb-3 md:pb-5">
        <h1 className=" bg-white w-full text-2xl md:text-5xl py-0 font-bold text-black">
          Activate Hardware ID
        </h1>
      </div>

      <form onSubmit={handleSubmit}>
        {!isNextClicked ? (
          <>
            <label className="text-[#BDBDBD] mb-5">Basics Details</label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-7 mt-4">
              <div className="space-y-6">
                <div className="space-y-2">
                  <label
                    htmlFor="hardwareId2"
                    className="text-black font-semibold"
                  >
                    Hardware ID *
                  </label>
                  <ReactSelect
                    value={fieldData.hardware_id}
                    onChange={(e) =>
                      setFieldData({ ...fieldData, hardware_id: e })
                    }
                    options={hardwareDropdownValues?.map((item) => {
                      return {
                        label: item.hardware_id,
                        value: item.hardware_id,
                      };
                    })}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: "#f5f7f9",
                        border: "none",
                        padding: "20px 24px",
                        borderRadius: "16px",
                      }),
                    }}
                    placeholder="Select a Hardware ID"
                    isClearable
                    required
                  />
                </div>

                {(fieldData.location_type == 2 ||
                  fieldData.location_type == 1) && (
                  <div className="space-y-2">
                    <label
                      htmlFor="hardwareId3"
                      className="text-black font-semibold"
                    >
                      Name of the Company*
                    </label>
                    <ReactSelect
                      value={fieldData.company_name}
                      onChange={(e) => {
                        setFieldData({
                          ...fieldData,
                          company_name: e,
                          branch: null,
                        });
                        fetchSubbranchList(e);
                      }}
                      options={headofficeDropdownValues?.map((item) => {
                        return {
                          label: item.name,
                          value: item._id,
                        };
                      })}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          backgroundColor: "#f5f7f9",
                          border: "none",
                          padding: "20px 24px",
                          borderRadius: "16px",
                        }),
                      }}
                      placeholder="Select a Company Name"
                      isClearable
                      required
                    />
                  </div>
                )}
              </div>
              <div className="space-y-6">
                <div className="space-y-2">
                  <label
                    htmlFor="hardwareId3"
                    className="text-black font-semibold"
                  >
                    Location Type*
                  </label>
                  <div className="flex space-x-4 pt-6 pb-7">
                    <input
                      id="hardwareId3_option1"
                      className="bg-gray-100 px-8 py-8 text-lg rounded-2xl outline-none text-gray-800"
                      type="radio"
                      name="location"
                      value="1"
                      defaultChecked={
                        fieldData.location_type === "1" ? true : false
                      }
                      onChange={(e) =>
                        setFieldData({
                          ...fieldData,
                          location_type: e.target.value,
                        })
                      }
                      required
                    />
                    <label
                      htmlFor="hardwareId3_option1"
                      className="text-gray-800"
                    >
                      Single Location
                    </label>
                    <input
                      id="hardwareId3_option2"
                      className="bg-gray-100 px-8 py-8 text-lg rounded-2xl outline-none text-gray-800"
                      type="radio"
                      name="location"
                      value="2"
                      defaultChecked={
                        fieldData.location_type === "2" ? true : false
                      }
                      onChange={(e) =>
                        setFieldData({
                          ...fieldData,
                          location_type: e.target.value,
                        })
                      }
                      required
                    />
                    <label
                      htmlFor="hardwareId3_option2"
                      className="text-gray-800"
                    >
                      Multiple Location
                    </label>
                  </div>
                </div>
                {fieldData.location_type == 2 && (
                  <div className="space-y-2 ">
                    <label
                      htmlFor="hardwareId4"
                      className="text-black font-semibold"
                    >
                      Name of the Branch*
                    </label>
                    <ReactSelect
                      value={fieldData.branch}
                      onChange={(e) => {
                        setFieldData({ ...fieldData, branch: e });
                      }}
                      // options={subBranchDropdownValues
                      //   .filter(
                      //     (item) =>
                      //       item.headbranch_id === fieldData.company_name?.value
                      //   )
                      //   .map((item) => {
                      //     return {
                      //       label: item.name,
                      //       value: item._id,
                      //     };
                      //   })}
                      options={subBranchDropdownValues.map((branch) => {
                        return { label: branch.name, value: branch._id };
                      })}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          backgroundColor: "#f5f7f9",
                          border: "none",
                          padding: "20px 24px",
                          borderRadius: "16px",
                        }),
                      }}
                      placeholder="Select a Branch"
                      isClearable
                      required
                    />
                  </div>
                )}
              </div>
            </div>

            {/* company details */}
            <div className="mt-10">
              <label className="text-[#BDBDBD] mb-5">
                Company/Contact Info
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-7 mt-4">
                <div className="space-y-6">
                  <div className="space-y-2">
                    <label
                      htmlFor="contactPersonName"
                      className="text-black font-semibold"
                    >
                      Contact Person Name*
                    </label>
                    <input
                      id="contactPersonName"
                      className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800"
                      type="text"
                      placeholder="Contact Person Name"
                      value={fieldData.co_person}
                      onChange={(e) =>
                        setFieldData({
                          ...fieldData,
                          co_person: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                  <div className="space-y-2">
                    <label
                      htmlFor="contactPersonEmail"
                      className="text-black font-semibold"
                    >
                      Contact Person Email*
                    </label>
                    <input
                      id="contactPersonEmail"
                      className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800"
                      type="email"
                      placeholder="Contact Person Email"
                      value={fieldData.co_person_email}
                      onChange={(e) => {
                        if (mailPattern.test(e.target.value)) {
                          setIsValid({ ...isValid, co_person_email: true });
                        } else {
                          setIsValid({ ...isValid, co_person_email: false });
                        }
                        setFieldData({
                          ...fieldData,
                          co_person_email: e.target.value,
                        });
                      }}
                      required
                    />
                  </div>
                </div>
                <div className="space-y-6">
                  <div className="space-y-2">
                    <label
                      htmlFor="contactPersonPhone"
                      className="text-black font-semibold"
                    >
                      Contact Person Phone no.*
                    </label>
                    <input
                      id="contactPersonPhone"
                      className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800 custom-number-input"
                      type="number"
                      placeholder="Contact Person Phone no."
                      value={fieldData.co_person_no}
                      onChange={(e) => {
                        if (phoneNumber.test(e.target.value.slice(0, 10))) {
                          setIsValid({ ...isValid, co_person_phone: true });
                        } else {
                          setIsValid({ ...isValid, co_person_phone: false });
                        }
                        setFieldData({
                          ...fieldData,
                          co_person_no: e.target.value.slice(0, 10),
                        });
                      }}
                      onKeyDown={(e) => {
                        if (
                          e.key === "e" ||
                          e.key === "E" ||
                          e.key === "-" ||
                          e.key === "+"
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => e.target.blur()}
                      required
                    />
                  </div>
                  <div className="space-y-2 grid grid-cols-1 gap-4">
                    <input
                      className="col-span-1 text-gray-100 px-8 py-7 mt-8 rounded-2xl outline-none bg-[#BDBDBD] cursor-pointer hover:bg-[#03438D] hover:text-white"
                      type="button"
                      value="NEXT"
                      onClick={handleNextClick}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div>
            <label className="text-[#BDBDBD] mb-5">Company Address</label>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-4">
              <div className="space-y-2">
                <label
                  htmlFor="locationPincode"
                  className="text-black font-semibold"
                >
                  Location Pincode*
                </label>
                <input
                  id="companyPincode"
                  className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800 custom-number-input"
                  type="number"
                  placeholder="Pincode"
                  onKeyDown={(e) => {
                    if (
                      e.key === "e" ||
                      e.key === "E" ||
                      e.key === "-" ||
                      e.key === "+"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                  value={fieldData.pincode}
                  onChange={(e) => {
                    setFieldData({
                      ...fieldData,
                      pincode: e.target.value.slice(0, 6),
                    });
                  }}
                  required
                />
              </div>
              <div className="space-y-2">
                <label
                  htmlFor="companyDistrict"
                  className="text-black font-semibold"
                >
                  Company District*
                </label>
                <input
                  id="companyDistrict"
                  className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800"
                  type="text"
                  placeholder="Enter the District"
                  value={fieldData.district}
                  onChange={(e) =>
                    setFieldData({ ...fieldData, district: e.target.value })
                  }
                  required
                />
              </div>
              <div className="space-y-2">
                <label
                  htmlFor="companyState"
                  className="text-black font-semibold"
                >
                  Company State*
                </label>
                <input
                  id="companyState"
                  className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800"
                  type="text"
                  placeholder="Enter the State"
                  value={fieldData.state}
                  onChange={(e) =>
                    setFieldData({ ...fieldData, state: e.target.value })
                  }
                  required
                />
              </div>
            </div>

            {/* Communication info */}
            <div className="mt-10">
              <label className="mb-5 text-[#BDBDBD]">Communication info</label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-7 mt-4">
                <div className="space-y-5 ">
                  <label
                    htmlFor="companyPincode"
                    className="text-black font-semibold"
                  >
                    Email for Normal Communication*
                  </label>
                  {normalEmail.map((n_email, i) => (
                    <input
                      key={i}
                      id="email"
                      className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800"
                      type="email"
                      placeholder="Enter the Email"
                      value={n_email}
                      onChange={(e) => handleNormalEmailChange(i, e)}
                      required={i === 0}
                    />
                  ))}
                </div>
                <div className="space-y-5">
                  <label
                    htmlFor="contactPersonEmail"
                    className="text-black font-semibold"
                  >
                    Phone no. for Normal Communication*
                  </label>
                  {normalPhone.map((n_phone, i) => (
                    <input
                      key={i}
                      id="phonenumber"
                      className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800 custom-number-input"
                      type="tel"
                      placeholder="Enter the Phone no."
                      // onKeyDown={(e) => {
                      //   if (
                      //     e.key === "e" ||
                      //     e.key === "E" ||
                      //     e.key === "-" ||
                      //     e.key === "+"
                      //   ) {
                      //     e.preventDefault();
                      //   }
                      // }}
                      // onWheel={(e) => e.target.blur()}
                      value={n_phone}
                      onChange={(e) => handleNormalPhoneChange(i, e)}
                      maxLength={10}
                      required={i === 0}
                    />
                  ))}
                </div>

                <div className="space-y-5 ">
                  <label
                    htmlFor="companyPincode"
                    className="text-black font-semibold"
                  >
                    Email for Critical Communication*
                  </label>
                  {criticalEmail.map((c_email, i) => (
                    <input
                      key={i}
                      id="email"
                      className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800"
                      type="email"
                      placeholder="Enter the Email"
                      value={c_email}
                      onChange={(e) => handleCriticalEmailChange(i, e)}
                      required={i === 0}
                    />
                  ))}
                </div>
                <div className="space-y-5">
                  <label
                    htmlFor="contactPersonEmail"
                    className="text-black font-semibold"
                  >
                    Phone no. for Critical Communication*
                  </label>
                  {criticalPhone.map((c_phone, i) => (
                    <input
                      key={i}
                      id="phonenumber"
                      className="w-full bg-[#f5f7f9] px-8 py-7 text-lg rounded-2xl outline-none text-gray-800 custom-number-input"
                      type="tel"
                      placeholder="Enter the Phone no."
                      // onKeyDown={(e) => {
                      //   if (
                      //     e.key === "e" ||
                      //     e.key === "E" ||
                      //     e.key === "-" ||
                      //     e.key === "+"
                      //   ) {
                      //     e.preventDefault();
                      //   }
                      // }}
                      // onWheel={(e) => e.target.blur()}
                      value={c_phone}
                      onChange={(e) => handleCriticalPhoneChange(i, e)}
                      maxLength={10}
                      required={i === 0}
                    />
                  ))}
                </div>
              </div>

              <div className="flex flex-col md:flex-row gap-4 md:gap-7 mt-5">
                <input
                  className="col-span-1 w-full text-[#f5f7f9] px-8 py-7 rounded-2xl outline-none bg-[#BDBDBD] cursor-pointer hover:bg-red-700 hover:text-white"
                  type="submit"
                  value="BACK"
                  onClick={handleBackClick}
                />

                <input
                  className="col-span-1 w-full text-gray-100 px-8 py-7 rounded-2xl outline-none bg-[#BDBDBD] cursor-pointer hover:bg-[#03438D] hover:text-white uppercase disabled:cursor-not-allowed"
                  type="submit"
                  value={loading ? "Loading..." : "CONTINUE"}
                  disabled={loading}
                />
              </div>
            </div>
          </div>
        )}
      </form>
    </div>
  );
}

export default AdminDashboard;
